import CompleteApiModel from '@widesk-ui/models/CompleteApiModel';

export default abstract class ServiceModel extends CompleteApiModel {
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	public get pagePath(): string {
		return this.pagePathPrefix + super.pagePath;
	}

	public get pagePathPrefix(): string {
		return `/configuration`;
	}
}